export default __webpack_public_path__ + "static/illustration-p2-998d986d16636c1ff3238e07590ae4d4.gif";